import React, {useEffect} from 'react';
import Stack from '@mui/material/Stack';
import axios from 'axios';
import '../../../styles/GroupManager.css'
import {TreeViewBaseItem} from '@mui/x-tree-view/models';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {getWithExpiry, refreshToken, setWithExpiry} from "../../../globals/GlobalFunctions";
import {GlobalConstants} from "../../../globals/GlobalConstants";
import Autocomplete from "@mui/material/Autocomplete";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

//axios.defaults.headers.common['Authorization'] = `Bearer ${}`;

function GroupManager() {
    const [groups, setGroups] = React.useState([]);
    const [validationText, setValidationText] = React.useState("");
    const [currentGroup, setCurrentGroup] = React.useState({group_ID: "", name: "", address: "", address2: "",
        admin_COBRA: false, city: "", election_Range: 0, employer_Size: "", first_Division_ID: "00000001", first_division_name: "", first_division_contract_coverage_End: "",
        first_division_contract_coverage_Start: "", first_Division_Network1: {networkID: "", networkDescription: ""}, first_Division_Network1_Priority: "",
        first_Division_Network2: {networkID: "", networkDescription: ""}, first_Division_Network3: {networkID: "", networkDescription: ""}, first_division_original_Date: "",
        first_division_plan_Year_1: "", first_division_plan_Year_2: "", original_Date: "", plan_Year_1_From_Date: "", plan_Year_1_Thru_Date: "", plan_Year_2_From_Date: "",
        plan_Year_2_Thru_Date: "", state: "", zip_Code: "", first_division_plans: [], first_Division_Network2_Priority: "",
        first_Division_Network3_Priority: "", vbasoftware_database: "CoastalAdminTest", vbapi_Token: "", eff_Date: "", federal_ID: "", rX_BIN: "", rX_PCN: "", rX_GRP: ""});
    const [loading, setLoading] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [validationError, setValidationError] = React.useState(false);
    const [currentDB, setCurrentDB] = React.useState("CoastalAdminTest");
    const [plans, setCurrentGroupPlans] = React.useState([]);
    const [networks, setNetworks] = React.useState([{networkID: "", networkDescription: ""}]);
    const [isUpdate, setIsUpdate] = React.useState(false);

    const handleChange = React.useCallback((e: any) => setCurrentGroup((prev: any) => ({ ...prev, [e.target.name]: e.target.value })), []);

    const handlePriorityChange = React.useCallback((e: any) => setCurrentGroup((prev: any) => ({ ...prev, [e.target.name]: e.target.value.replace(/[^0-9]/g, '') })), []);

    const handleCheck = React.useCallback((e: any) => setCurrentGroup((prev: any) => ({ ...prev, [e.target.name]: e.target.checked})), []);

    const handleEmployerSizeSelect = React.useCallback((e: any, newValue: any) => {
        if(newValue !== null) {
            setCurrentGroup((prev: any) => ({...prev, employer_Size: newValue}))
        }
        else {
            setCurrentGroup((prev: any) => ({...prev, employer_Size: ""}))
        }
    }, []);

    const handleStateSelect = React.useCallback((e: any, newValue: any) => {
        if(newValue !== null) {
            setCurrentGroup((prev: any) => ({...prev, state: newValue}))
        }
        else {
            setCurrentGroup((prev: any) => ({...prev, state: ""}))
        }
    }, []);

    const handlePlanSelect = React.useCallback((e: any, newValue: any) => {
        if(newValue !== null) {
            setCurrentGroup((prev: any) => ({...prev, first_division_plans: newValue}))
        }
        else {
            setCurrentGroup((prev: any) => ({...prev, first_division_plans: ""}))
        }
    }, []);

    const handleNetwork1Select = React.useCallback((e: any, newValue: any) => {
        if(newValue !== null) {
            setCurrentGroup((prev: any) => ({ ...prev, first_Division_Network1: {networkID: newValue.networkID, networkDescription:  newValue.networkDescription } }))
        }
        else {
            setCurrentGroup((prev: any) => ({ ...prev, first_Division_Network1: {networkID: "", networkDescription:  "" } }))
        }
    }, []);

    const handleNetwork2Select = React.useCallback((e: any, newValue: any) => {
        if(newValue !== null) {
            setCurrentGroup((prev: any) => ({ ...prev, first_Division_Network2: {networkID: newValue.networkID, networkDescription:  newValue.networkDescription } }))
        }
        else {
            setCurrentGroup((prev: any) => ({ ...prev, first_Division_Network2: {networkID: "", networkDescription:  "" } }))
        }
    }, []);

    const handleNetwork3Select = React.useCallback((e: any, newValue: any) => {
        if(newValue !== null) {
            setCurrentGroup((prev: any) => ({ ...prev, first_Division_Network3: {networkID: newValue.networkID, networkDescription:  newValue.networkDescription } }))
        }
        else {
            setCurrentGroup((prev: any) => ({ ...prev, first_Division_Network3: {networkID: "", networkDescription:  "" } }))
        }
    }, []);

    //const handleNetwork1InputSelect = React.useCallback((e: any, newValue: any) => setCurrentGroup((prev: any) => ({ ...prev, first_Division_Network1ID: newValue.networkID })), []);
    //const handleEmployerSizeSelect = React.useCallback((e: any) => console.log(e), []);

    const handleOriginalDateChange = (e: any) => {
        setCurrentGroup((prev: any) => ({ ...prev, original_Date: e.format('MM/DD/YYYY') }));
        //console.log(currentGroup);
    }

    const handleFDOriginalDateChange = (e: any) => {
        setCurrentGroup((prev: any) => ({ ...prev, first_division_original_Date: e.format('MM/DD/YYYY') }));
    }

    const handleFDCovStartDateChange = (e: any) => {
        setCurrentGroup((prev: any) => ({ ...prev, first_division_contract_coverage_Start: e.format('MM/DD/YYYY') }));
    }

    const handleFDCovEndDateChange = (e: any) => {
        setCurrentGroup((prev: any) => ({ ...prev, first_division_contract_coverage_End: e.format('MM/DD/YYYY') }));
    }

    const handlePlanYear1FromDateChange = (e: any) => {
        setCurrentGroup((prev: any) => ({ ...prev, plan_Year_1_From_Date: e.format('MM/DD/YYYY') }));
    }

    const handlePlanYear1ThruDateChange = (e: any) => {
        setCurrentGroup((prev: any) => ({ ...prev, plan_Year_1_Thru_Date: e.format('MM/DD/YYYY') }));
    }

    const handlePlanYear2FromDateChange = (e: any) => {
        setCurrentGroup((prev: any) => ({ ...prev, plan_Year_2_From_Date: e.format('MM/DD/YYYY') }));
    }

    const handlePlanYear2ThruDateChange = (e: any) => {
        setCurrentGroup((prev: any) => ({ ...prev, plan_Year_2_Thru_Date: e.format('MM/DD/YYYY') }));
    }

    const handleEffDateChange = (e: any) => {
        setCurrentGroup((prev: any) => ({ ...prev, eff_Date: e.format('MM/DD/YYYY') }));
    }

    const onDBChange = React.useCallback((e: any, newDB: any) => setCurrentDB(newDB.id), []);

    const initialGroupState = {
        group_ID: "",
        name: "",
        address: "",
        address2: "",
        admin_COBRA: false,
        city: "",
        election_Range: 0,
        employer_Size: "",
        first_Division_ID: "00000001",
        first_division_name: "",
        first_division_contract_coverage_End: "",
        first_division_contract_coverage_Start: "",
        first_Division_Network1: {networkID: "", networkDescription: ""},
        first_Division_Network1_Priority: "",
        first_Division_Network2: {networkID: "", networkDescription: ""},
        first_Division_Network2_Priority: "",
        first_Division_Network3: {networkID: "", networkDescription: ""},
        first_Division_Network3_Priority: "",
        first_division_original_Date: "",
        first_division_plan_Year_1: "",
        first_division_plan_Year_2: "",
        original_Date: "",
        plan_Year_1_From_Date: "",
        plan_Year_1_Thru_Date: "",
        plan_Year_2_From_Date: "",
        plan_Year_2_Thru_Date: "",
        state: "",
        zip_Code: "",
        first_division_plans: [],
        vbasoftware_database: "CoastalAdminTest",
        vbapi_Token: "",
        eff_Date: "",
        federal_ID: "",
        rX_BIN: "",
        rX_PCN: "",
        rX_GRP: ""
    }

    const handleValidationClose = () => {
        setValidationError(false);
    }

    let token = localStorage.getItem('jwt');
    //console.log('jwt', token);

    type treeGroups = TreeViewBaseItem<{
        group_ID: string;
        label: string;
    }>;

    const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
        color: theme.palette.grey[200],
        [`& .${treeItemClasses.content}`]: {
            [`& .${treeItemClasses.label}`]: {
                fontSize: '1.4vh',
                fontWeight: 500,
            },
        }}),
        );

    const getGroup = (groupID : string) => {
        setIsLoading(true);
        refreshToken();
        var vbapi_Token = getWithExpiry('vbapi_Token');
        if(vbapi_Token == null || vbapi_Token === ""){
            vbapi_Token = "empty";
        }
        axios
            .get(
                localStorage.getItem('baseURL') + 'group/get/' + groupID + '/' + currentDB + '/' + vbapi_Token,
                {headers: {'Authorization': `Bearer ${token}`}}
            )
            .then((response) => {
                //console.log(response);
                setCurrentGroup({...currentGroup, ...response.data});
                setWithExpiry("vbapi_Token", response.data.vbapi_Token);
                setIsLoading(false);
                setIsUpdate(true);
            })
            .catch(function (error) {
                setIsLoading(false);
            });
    }

    function handleTreeViewSelect(event: React.SyntheticEvent, id: string | null) {
        if (id){
            getGroup(id);
        }
    }

    const clearGroup = () => {
        //console.log(currentGroup);
        setCurrentGroup({...initialGroupState});
        setIsUpdate(false);
    }

    useEffect(() => {
        setIsLoading(true);
        getGroupList();
        getPlanIDs();
        getNetworks();
        clearGroup();
    }, [currentDB]);

    const getGroupList = async () => {
        refreshToken();
        var vbapi_Token = getWithExpiry('vbapi_Token');
        if(vbapi_Token == null || vbapi_Token === ""){
            vbapi_Token = "empty";
        }
        const response =
            await axios
                .get(
                    localStorage.getItem('baseURL') + 'group/getList/' + currentDB + '/' + vbapi_Token,
                    {headers: {'Authorization': `Bearer ${token}`}}
                );
        //console.log(response);
        setGroups(response.data);
        setWithExpiry("vbapi_Token", response.data.vbapi_Token);
        setIsLoading(false);
    }

    const getPlanIDs = async () => {
        refreshToken();
        var vbapi_Token = getWithExpiry('vbapi_Token');
        if(vbapi_Token == null || vbapi_Token === ""){
            vbapi_Token = "empty";
        }
        const response =
            await axios
                .get(
                    localStorage.getItem('baseURL') + 'plan/getIDs/' + currentDB + '/' + vbapi_Token,
                    {headers: {'Authorization': `Bearer ${token}`}}
                );
        //console.log(response);
        setCurrentGroupPlans(response.data);
        setWithExpiry("vbapi_Token", response.data.vbapi_Token);
    }

    const getNetworks = async () => {
        refreshToken();
        var vbapi_Token = getWithExpiry('vbapi_Token');
        if(vbapi_Token == null || vbapi_Token === ""){
            vbapi_Token = "empty";
        }
        const response =
            await axios
                .get(
                    localStorage.getItem('baseURL') + 'network/getList/' + currentDB + '/' + vbapi_Token,
                    {headers: {'Authorization': `Bearer ${token}`}}
                );
        //console.log(response);
        setNetworks(response.data);
        setWithExpiry("vbapi_Token", response.data.vbapi_Token);
    }

    const validateGroup = () => {
        setLoading(true);
        if (!(currentGroup.group_ID.length > 0)) {
            setLoading(false);
            setValidationText("ID is required!")
            setValidationError(true);
        }
        else if (!(currentGroup.name.length > 0)) {
            setLoading(false);
            setValidationText("Name is required!")
            setValidationError(true);
        }
        else if (!(currentGroup.address.length > 0)) {
            setLoading(false);
            setValidationText("Address is required!")
            setValidationError(true);
        }
        else if (!(currentGroup.city.length > 0)) {
            setLoading(false);
            setValidationText("City is required!")
            setValidationError(true);
        }
        else if (!(currentGroup.original_Date.length > 0)) {
            setLoading(false);
            setValidationText("Original Date is required!")
            setValidationError(true);
        }
        else if (!(currentGroup.state.length > 0)) {
            setLoading(false);
            setValidationText("State is required!")
            setValidationError(true);
        }
        else if (!(currentGroup.zip_Code.length > 0)) {
            setLoading(false);
            setValidationText("Zip Code is required!")
            setValidationError(true);
        }
        else if (!(currentGroup.first_Division_ID.length > 0)) {
            setLoading(false);
            setValidationText("First Division is required!")
            setValidationError(true);
        }
        else if (!(currentGroup.first_division_name.length > 0)) {
            setLoading(false);
            setValidationText("First Division Name is required!")
            setValidationError(true);
        }
        else if (!(currentGroup.first_division_original_Date.length > 0)) {
            setLoading(false);
            setValidationText("First Division Original Date is required!")
            setValidationError(true);
        }
        else if (!(currentGroup.first_division_contract_coverage_Start.length > 0)) {
            setLoading(false);
            setValidationText("First Division Coverage Start is required!")
            setValidationError(true);
        }
        else if (!(currentGroup.first_division_contract_coverage_End.length > 0)) {
            setLoading(false);
            setValidationText("First Division Coverage End is required!")
            setValidationError(true);
        }
        else {
            saveGroup();
        }
    }

    const saveGroup = async () => {
        refreshToken();
        currentGroup.vbasoftware_database = currentDB;
        currentGroup.vbapi_Token = getWithExpiry('vbapi_Token');
        const response =
            await axios
                .put(
                    localStorage.getItem('baseURL') + 'group/put',
                    currentGroup,
                    {headers: {'Authorization': `Bearer ${token}`, accept: "*/*", "Content-Type": "application/json"}}
                ).then(() => {
                    setLoading(false);
                    setSuccessAlert(true);
                    setIsUpdate(true);
                    getGroupList();
                }).catch((error) => {
                    //console.log(response);
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                });
        //console.log(response);
    }

    const getItemId = (item: treeGroups) => item.group_ID;

    return (
        <div>
            <Box sx={{overflowY: 'scroll', border: '2px solid #3B6BA3', background: '#3B6BA3', borderRadius: '10px', maxWidth: '13%', minWidth: '13%'}}
                 style={{float: "right", minHeight: '70vh', maxHeight: '70vh'}}>
                <div style={{padding: "1vh", marginLeft: '2vh'}}><b>Groups</b></div>
                <RichTreeView items={groups} slots={{item: CustomTreeItem}} getItemId={getItemId}
                              onSelectedItemsChange={handleTreeViewSelect}/>
            </Box>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="groupFormContainer">

                    {/* Row 1: Group ID, Name, Address, Address2, City, Original Date */}
                    <div className="groupFormRow groupFormRow-6col">
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Group ID</span>
                            <TextField name="group_ID" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.group_ID} onChange={handleChange} disabled={isUpdate}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Name</span>
                            <TextField name="name" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.name} onChange={handleChange}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Address</span>
                            <TextField name="address" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.address} onChange={handleChange}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Address 2</span>
                            <TextField name="address2" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.address2} onChange={handleChange}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">City</span>
                            <TextField name="city" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.city} onChange={handleChange}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Original Date</span>
                            <DatePicker name="original_Date" className="datePickerFull"
                                        value={dayjs(currentGroup.original_Date)}
                                        onChange={(newValue) => handleOriginalDateChange(newValue)}
                                        slotProps={{ textField: { size: 'small', fullWidth: true } }}/>
                        </div>
                    </div>

                    {/* Row 2: Admin COBRA, Employer Size, State, Zip, RX Bin, RX PCN, RX GRP */}
                    <div className="groupFormRow groupFormRow-7col">
                        <div className="groupFormField groupFormField-checkbox">
                            <span className="groupFieldLabel groupFieldLabel-checkbox">Admin COBRA</span>
                            <Checkbox name="admin_COBRA"
                                      sx={{ color: "white", padding: '4px 0', width: 'fit-content' }}
                                      checked={currentGroup.admin_COBRA}
                                      onChange={handleCheck}
                                      inputProps={{'aria-label': 'controlled'}}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Employer Size</span>
                            <Autocomplete className="selectFull" size="small" disablePortal
                                          options={GlobalConstants.Employer_Size}
                                          value={currentGroup.employer_Size}
                                          inputValue={currentGroup.employer_Size}
                                          renderInput={(params) => <TextField {...params}/>}
                                          onChange={(event, newValue) => handleEmployerSizeSelect(event, newValue)}
                                          isOptionEqualToValue={(option, value) => option === value}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">State</span>
                            <Autocomplete className="selectFull" size="small" disablePortal
                                          options={GlobalConstants.State_Abbreviations}
                                          value={currentGroup.state}
                                          renderInput={(params) => <TextField {...params}/>}
                                          onChange={(event, newValue) => handleStateSelect(event, newValue)}
                                          isOptionEqualToValue={(option, value) => option === value}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Zip Code</span>
                            <TextField name="zip_Code" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.zip_Code} onChange={handleChange}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">RX Bin</span>
                            <TextField name="rX_BIN" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.rX_BIN} onChange={handleChange}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">RX PCN</span>
                            <TextField name="rX_PCN" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.rX_PCN} onChange={handleChange}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">RX GRP</span>
                            <TextField name="rX_GRP" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.rX_GRP} onChange={handleChange}/>
                        </div>
                    </div>

                    {/* Row 3: First Division fields */}
                    <div className="groupFormRow groupFormRow-5col">
                        <div className="groupFormField">
                            <span className="groupFieldLabel">First Division</span>
                            <TextField name="first_Division_ID" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.first_Division_ID} onChange={handleChange} disabled={isUpdate}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">First Division Name</span>
                            <TextField name="first_division_name" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.first_division_name} onChange={handleChange} disabled={isUpdate}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">First Division Orig. Date</span>
                            <DatePicker name="first_division_original_Date" className="datePickerFull"
                                        value={dayjs(currentGroup.first_division_original_Date)}
                                        onChange={(newValue) => handleFDOriginalDateChange(newValue)} disabled={isUpdate}
                                        slotProps={{ textField: { size: 'small', fullWidth: true } }}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Contract Start</span>
                            <DatePicker name="first_division_contract_coverage_Start" className="datePickerFull"
                                        value={dayjs(currentGroup.first_division_contract_coverage_Start)}
                                        onChange={(newValue) => handleFDCovStartDateChange(newValue)} disabled={isUpdate}
                                        slotProps={{ textField: { size: 'small', fullWidth: true } }}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Contract End</span>
                            <DatePicker name="first_division_contract_coverage_End" className="datePickerFull"
                                        value={dayjs(currentGroup.first_division_contract_coverage_End)}
                                        onChange={(newValue) => handleFDCovEndDateChange(newValue)} disabled={isUpdate}
                                        slotProps={{ textField: { size: 'small', fullWidth: true } }}/>
                        </div>
                    </div>

                    {/* Row 4: Plan Years */}
                    <div className="groupFormRow groupFormRow-6col">
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Plan Year 1</span>
                            <TextField name="first_division_plan_Year_1" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.first_division_plan_Year_1} onChange={handleChange} disabled={isUpdate}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Plan Year 1 From</span>
                            <DatePicker name="plan_Year_1_From_Date" className="datePickerFull"
                                        value={dayjs(currentGroup.plan_Year_1_From_Date)}
                                        onChange={(newValue) => handlePlanYear1FromDateChange(newValue)} disabled={isUpdate}
                                        slotProps={{ textField: { size: 'small', fullWidth: true } }}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Plan Year 1 To</span>
                            <DatePicker name="plan_Year_1_Thru_Date" className="datePickerFull"
                                        value={dayjs(currentGroup.plan_Year_1_Thru_Date)}
                                        onChange={(newValue) => handlePlanYear1ThruDateChange(newValue)} disabled={isUpdate}
                                        slotProps={{ textField: { size: 'small', fullWidth: true } }}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Plan Year 2</span>
                            <TextField name="first_division_plan_Year_2" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.first_division_plan_Year_2} onChange={handleChange} disabled={isUpdate}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Plan Year 2 From</span>
                            <DatePicker name="plan_Year_2_From_Date" className="datePickerFull"
                                        value={dayjs(currentGroup.plan_Year_2_From_Date)}
                                        onChange={(newValue) => handlePlanYear2FromDateChange(newValue)} disabled={isUpdate}
                                        slotProps={{ textField: { size: 'small', fullWidth: true } }}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Plan Year 2 To</span>
                            <DatePicker name="plan_Year_2_Thru_Date" className="datePickerFull"
                                        value={dayjs(currentGroup.plan_Year_2_Thru_Date)}
                                        onChange={(newValue) => handlePlanYear2ThruDateChange(newValue)} disabled={isUpdate}
                                        slotProps={{ textField: { size: 'small', fullWidth: true } }}/>
                        </div>
                    </div>

                    {/* Row 5: Networks */}
                    <div className="groupFormRow groupFormRow-netwk">
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Network 1</span>
                            <Autocomplete className="selectFull" size="small" disablePortal
                                          options={networks} getOptionLabel={(network) => network.networkDescription}
                                          value={currentGroup.first_Division_Network1}
                                          renderInput={(params) => <TextField {...params}/>}
                                          onChange={(event, newValue) => handleNetwork1Select(event, newValue)}
                                          isOptionEqualToValue={(option, value) => option.networkID === value.networkID}
                                          disabled={isUpdate}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Priority</span>
                            <TextField name="first_Division_Network1_Priority" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.first_Division_Network1_Priority} onChange={handlePriorityChange} disabled={isUpdate}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Network 2</span>
                            <Autocomplete className="selectFull" size="small" disablePortal
                                          options={networks} getOptionLabel={(network) => network.networkDescription}
                                          value={currentGroup.first_Division_Network2}
                                          renderInput={(params) => <TextField {...params}/>}
                                          onChange={(event, newValue) => handleNetwork2Select(event, newValue)}
                                          isOptionEqualToValue={(option, value) => option.networkID === value.networkID}
                                          disabled={isUpdate}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Priority</span>
                            <TextField name="first_Division_Network2_Priority" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.first_Division_Network2_Priority} onChange={handlePriorityChange} disabled={isUpdate}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Network 3</span>
                            <Autocomplete className="selectFull" size="small" disablePortal
                                          options={networks} getOptionLabel={(network) => network.networkDescription}
                                          value={currentGroup.first_Division_Network3}
                                          renderInput={(params) => <TextField {...params}/>}
                                          onChange={(event, newValue) => handleNetwork3Select(event, newValue)}
                                          isOptionEqualToValue={(option, value) => option.networkID === value.networkID}
                                          disabled={isUpdate}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Priority</span>
                            <TextField name="first_Division_Network3_Priority" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.first_Division_Network3_Priority} onChange={handlePriorityChange} disabled={isUpdate}/>
                        </div>
                    </div>

                    {/* Row 6: Network Eff. Date, Plans, Tax ID */}
                    <div className="groupFormRow groupFormRow-eff">
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Network Eff. Date</span>
                            <DatePicker name="eff_Date" className="datePickerFull"
                                        value={dayjs(currentGroup.eff_Date)}
                                        onChange={(newValue) => handleEffDateChange(newValue)} disabled={isUpdate}
                                        slotProps={{ textField: { size: 'small', fullWidth: true } }}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Plans</span>
                            <Autocomplete className="selectFull" multiple size="small" limitTags={2} disablePortal
                                          options={plans} value={currentGroup.first_division_plans}
                                          renderInput={(params) => <TextField {...params}/>}
                                          onChange={(event, newValue) => handlePlanSelect(event, newValue)}
                                          isOptionEqualToValue={(option, value) => option === value}
                                          disabled={isUpdate}/>
                        </div>
                        <div className="groupFormField">
                            <span className="groupFieldLabel">Tax ID</span>
                            <TextField name="federal_ID" variant="outlined" size="small" fullWidth className="groupInputFull"
                                       value={currentGroup.federal_ID} onChange={handleChange}/>
                        </div>
                    </div>

                </div>
            </LocalizationProvider>

            <Dialog open={validationError} onClose={handleValidationClose}
                    aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{"Validation Error"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{validationText}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleValidationClose}>OK</Button>
                </DialogActions>
            </Dialog>

            {successAlert &&
                <Alert className="groupAlertStyles" severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                    <AlertTitle>Success!</AlertTitle>
                    Group Saved Successfully!
                </Alert>}<Stack spacing={5} direction="row" className="groupButtonBar">
            <Autocomplete className="dbSelect" size="small" disablePortal disableClearable
                          options={GlobalConstants.VBA_DB}
                          value={GlobalConstants.VBA_DB.find(option => option.id === currentDB) || null}
                          sx={{width: 150}} defaultValue={GlobalConstants.VBA_DB[0]}
                          renderInput={(params) => <TextField {...params}/>}
                          onChange={onDBChange}/>
            <Button variant="contained" onClick={clearGroup} size="large">Clear</Button>
            <LoadingButton variant="contained" onClick={validateGroup} size="large"
                           loading={loading} loadingPosition="start" startIcon={<SaveIcon/>}>Save</LoadingButton>
        </Stack>

            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        </div>
    );

}

export default React.memo(GroupManager);